export default __webpack_public_path__ + "static/media/cancer_banner_Hk.ea081493.webp";